import { Component, Inject } from '@angular/core';
import { MatDialogRef , MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { TUI_COUNTRIES } from '@taiga-ui/kit';
import { delay, Observable } from 'rxjs';
import { AWSLambda } from 'src/app/AWSLambda.service';

@Component({
  selector: 'app-countries-modal',
  templateUrl: './countries-modal.component.html',
  })
export class CountriesModalComponent {
  countries: TuiCountryIsoCode[] = [];
  val = ''
  
  //readonly countries = Object.values(TuiCountryIsoCode);
  //readonly countries = Object.values(['AD', 'AE', 'AF', 'AG', 'AI'])


  constructor(
    public dialog: MatDialogRef<CountriesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: TuiCountryIsoCode[],
    @Inject(TUI_COUNTRIES)
    readonly countriesNames$: Observable<Record<TuiCountryIsoCode, string>>,
    
  ) { 
    //const countriesFromAPI = ['us', 'mx', 'co', 'gb'];
    this.countries = data;

  }

  close(): void {
    this.dialog.close(false);
  }
  confirm(value: TuiCountryIsoCode): void {
    this.dialog.close(value);
  }  
}
